import {
  UpdateQuoteSheetRequest,
  UpdateQuoteSheetResponse,
} from './quote-sheets-types';
import useMutationApi from '../useMutationApi';
import { useQueryClient } from '@tanstack/react-query';

export function useUpdateQuoteSheet({
  quoteSheetId,
}: {
  quoteSheetId: string;
}) {
  const queryClient = useQueryClient();
  return useMutationApi<
    { quoteSheetId: string } & UpdateQuoteSheetRequest,
    UpdateQuoteSheetResponse
  >({
    endpoint: `accounts-payable/quote-sheets/${quoteSheetId}`,
    method: 'PATCH',
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [
            `accounts-payable/quote-sheets/${quoteSheetId}`,
            undefined,
          ],
        });
      },
    },
  });
}
